import { LoginPage } from "@/components/admin/login-page";

export const StartPage = () => {
  // Always go directly to login page
  // Super admin is created via seed.sql, so initialization check is not needed
  return <LoginPage redirectTo="/" />;
};
